'use strict';

import $ from 'jquery';
import Swal from 'sweetalert2';
import { loadHiddenBlocks, handleDependentFields } from '../../utils/dependentFields.js';

// Inscreve o usuário selecionado
const subscribe = (challenge_id, user_id) => {
  disableButton('Adicionando voluntário, aguarde ...');

  $.ajax({
    type: 'POST',
    url: '/voluntarios-participantes/efetuar-inscricao',
    data: {
      challenge_id,
      user_id,
      _token: $('meta[name="csrf-token"]').attr('content'),
    },
    dataType: 'json',
    success: function (data) {
      if (data.type === 'success') {
        $('#subscribes-table').append(data.html);

        if (data.subscribes) {
          $('.js-counter').html(data.subscribes);
        }

        if (data.free_vacancies) {
          $('.js-free-vacancies').html(data.free_vacancies);
        }

        $('.js-data-user').val('').trigger('change');
      }

      enableButton('Incluir voluntário na ação');

      Swal.fire(data.title, data.message, data.type);
    },
    error: function (XMLHttpRequest, textStatus, errorThrown) {
      enableButton('Incluir voluntário na ação');
    },
  });
};

// Desabilita o botão de inclusão
const disableButton = text => {
  $('.js-include-volunteer').prop('disabled', true);
  $('.js-include-volunteer').text(text);
};

// Habilita o botão de inclusão
const enableButton = text => {
  $('.js-include-volunteer').prop('disabled', false);
  $('.js-include-volunteer').text(text);
};

// Abre o formulário de inscrição
const callForm = (challenge_id, user_id) => {
  $.ajax({
    type: 'POST',
    url: '/formulario-de-acao/',
    data: {
      challenge_id,
      user_id,
      _token: $('meta[name="csrf-token"]').attr('content'),
    },
    dataType: 'json',
    success: function (data) {
      if (data.success) {
        $('body').append(data.html);
      } else {
        Swal.fire(data.title, data.message, data.type);
      }
    },
  });
};

const show = {
  init() {
    $(document).on('click', '.js-include-volunteer', function (e) {
      e.preventDefault();

      const challenge_id = $(this).attr('data-challenge');
      const user_id = $('.js-data-user').val();
      const has_form = !!$('[name="has_form"]').length;

      if (has_form) {
        callForm(challenge_id, user_id);
      } else {
        subscribe(challenge_id, user_id);
      }
    });

    // Remove atributo required dos campos em blocos ocultos ao carregar a página
    loadHiddenBlocks();

    // Abre campos dependentes
    handleDependentFields();

    // Submit do formulário
    $(document).on('submit', '.js-form-modal', function (e) {
      e.preventDefault();

      $.ajax({
        type: 'POST',
        url: '/formulario-de-acao/enviar',
        data: $(this).serialize(),
        dataType: 'json',
        success: function (data) {
          if (data.success) {
            $('#modal-form').remove();
            subscribe(data.challenge_id, data.user_id);
          }
        },
      });
    });

    $(document).on('click', '.js-include-volunteer-external', function (e) {
      e.preventDefault();

      function isEmail(email) {
        var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        return regex.test(email);
      }

      if (isEmail($('.js-data-external').val())) {
        $('.js-include-volunteer-external').prop('disabled', true);
        $('.js-include-volunteer-external').text('Enviando convite, aguarde ...');

        var post = {};

        post.challenge_id = $(this).attr('data-challenge');
        post.email = $('.js-data-external').val();
        post._token = $('meta[name="csrf-token"]').attr('content');

        var url = '/convidar-voluntario';

        $.ajax({
          type: 'POST',
          url: url,
          data: post,
          dataType: 'json',
          success: function (data) {
            $('.js-data-external').val('');
            $('.js-include-volunteer-external').prop('disabled', false);
            $('.js-include-volunteer-external').text('ENVIAR CONVITE');
            $('#invites-table').append(data.html);
            $('.js-subscribes-counter').html(data.counter);
            Swal.fire(data.title, data.message, data.type);
          },
          error: function (XMLHttpRequest, textStatus, errorThrown) {
            $('.js-include-volunteer-external').prop('disabled', false);
            $('.js-include-volunteer-external').text('ENVIAR CONVITE');
          },
        });
      } else {
        Swal.fire('Atenção', 'Informe um e-mail válido!', 'error');
      }

      return false;
    });

    function formatOptions(opt) {
      if (opt.name) {
        var $opt = $(
          `<div class="u-size-16 u-m-b-10">
            <b>${opt.name} ${opt.enrollment && '(' + opt.enrollment + ')'}</b><br/>
            ${opt.vp && opt.vp + '<br/>'}
            ${opt.superintendent && opt.superintendent + '<br/>'}
            ${opt.regional && opt.regional}
          </div>`
        );
      } else {
        var $opt = $(`<div class="u-size-16 u-m-b-10">Selecione um voluntário</div>`);
      }
      return $opt;
    }

    function matchCustom(params, data) {
      // If there are no search terms, return all of the data
      if ($.trim(params.term) === '') {
        return data;
      }

      // Do not display the item if there is no 'text' property
      if (typeof data.name === 'undefined') {
        return null;
      }

      // `params.term` should be the term that is used for searching
      // `data.name, data.email and data.enrollment` is the text that is displayed for the data object
      if (
        data.name.toLowerCase().includes(params.term.toLowerCase()) ||
        data.enrollment.toLowerCase().includes(params.term.toLowerCase()) ||
        data.vp.toLowerCase().includes(params.term.toLowerCase()) ||
        data.superintendent.toLowerCase().includes(params.term.toLowerCase()) ||
        data.regional.toLowerCase().includes(params.term.toLowerCase())
      ) {
        var modifiedData = $.extend({}, data, true);
        modifiedData.text += ' (matched)';

        // You can return modified objects from here
        // This includes matching the `children` how you want in nested data sets
        return modifiedData;
      }

      // Return `null` if the term should not be displayed
      return null;
    }

    fetch(`${window.location.origin}/get/users`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('input[name="_token"]').value,
      },
    })
      .then(response => (response.ok ? response.json() : console.log('Network response was not ok.')))
      .then(data => {
        $('.js-data-user').select2({
          theme: 'classic',
          placeholder: 'Selecione o voluntário',
          data: JSON.parse(data.users),
          templateSelection: formatOptions,
          templateResult: formatOptions,
          matcher: matchCustom,
          language: {
            noResults: function () {
              return 'Nenhum resultado encontrado.';
            },
          },
          escapeMarkup: function (markup) {
            return markup;
          },
        });
      })
      .catch(error => {
        console.log('There has been a problem with your fetch operation: ' + error.message);
      });
  },
};

export default show;
